import Vue from "vue";
import { SET_COLLAPSE_PROFILE_BOX, SET_DISMISS_MISSING_FILOGIX_DETAILS_BANNER } from "./browser-preferences-mutations";
export const CHANGE_COLLAPSE_BOX = "CHANGE_COLLAPSE_BOX";
export const DISMISS_MISSING_FILOGIX_DETAILS_BANNER = "DISMISS_MISSING_FILOGIX_DETAILS_BANNER";
const actions = {
  [CHANGE_COLLAPSE_BOX]: (context, {
    collapseComponentName,
    isCollapsed
  }) => {
    const {
      username
    } = Vue.auth.session.get().userDetails;
    context.commit(SET_COLLAPSE_PROFILE_BOX, {
      username,
      collapseComponentName,
      isCollapsed
    });
  },
  [DISMISS_MISSING_FILOGIX_DETAILS_BANNER]: (context, applicationId) => {
    const {
      username
    } = Vue.auth.session.get().userDetails;
    context.commit(SET_DISMISS_MISSING_FILOGIX_DETAILS_BANNER, {
      username,
      applicationId
    });
  }
};
export default actions;